import PropTypes from 'prop-types';
import React from 'react';
import Col from 'react-bootstrap/lib/Col';
import Row from 'react-bootstrap/lib/Row';

import Order from '../../../records/Order';
import { translate as t } from '../../../lib/I18n';

import Price from '../../general/Price';
import PaymentCardDetails from '../../payment/PaymentCardDetails';
import PaypalPaymentDetails from '../../payment/PaypalPaymentDetails';
import AmazonPayPaymentDetails from '../../payment/AmazonPayPaymentDetails';
import ApplePayPaymentDetails from '../../payment/ApplePayPaymentDetails';
import GooglePayPaymentDetails from '../../payment/GooglePayPaymentDetails';

class PaymentInformation extends React.PureComponent {

    static propTypes = {
        order: PropTypes.instanceOf(Order).isRequired
    };

    renderPaymentDetails (type) {
        const { order } = this.props;

        const cards = order[type].getCards();
        const voucherAmount = order.getVoucherPaymentAmount(type);
        const paypalPayment = order.getPaypalPayment(type);
        const amazonPayPayment = order.getAmazonPayPayment(type);
        const applePayPayment = order.getApplePayPayment(type);
        const googlePayPayment = order.getGooglePayPayment(type);

        return (
            <Row>
                { voucherAmount > 0 &&
                    <div>
                        <Col xs={ 8 }>{ t('account.orders.eVoucherPayment', { count: order.payments.warrants.size }) }</Col>
                        <Col xs={ 4 } className="text-right price"><Price price={ voucherAmount } /></Col>
                    </div> }
                { order.hasCardPayment() && cards.filter((card) => card.amount > 0).map((card, index) =>
                    <div key={ index }>
                        <Col xs={ 8 }><PaymentCardDetails card={ card } /></Col>
                        <Col xs={ 4 } className="text-right price"><Price price={ card.amount } /></Col>
                    </div>
                ) }
                { paypalPayment &&
                    <div>
                        <Col xs={ 8 }><PaypalPaymentDetails payment={ paypalPayment } /></Col>
                        <Col xs={ 4 } className="text-right price"><Price price={ paypalPayment.amount } /></Col>
                    </div> }
                { amazonPayPayment &&
                    <div>
                        <Col xs={ 8 }><AmazonPayPaymentDetails payment={ amazonPayPayment } /></Col>
                        <Col xs={ 4 } className="text-right price"><Price price={ amazonPayPayment.amount } /></Col>
                    </div> }
                { applePayPayment &&
                    <div>
                        <Col xs={ 8 }><ApplePayPaymentDetails payment={ applePayPayment } /></Col>
                        <Col xs={ 4 } className="text-right price"><Price price={ applePayPayment.amount } /></Col>
                    </div> }
                { googlePayPayment &&
                    <div>
                        <Col xs={ 8 }><GooglePayPaymentDetails payment={ googlePayPayment } /></Col>
                        <Col xs={ 4 } className="text-right price"><Price price={ googlePayPayment.amount } /></Col>
                    </div> }
            </Row>
        );
    }

    render () {
        const { order } = this.props;

        if (!order.isPaid() || order.isFullRefund) {
            return null;
        }

        return (
            <Row>
                <Col xs={ 12 }>
                    <div className="padding-bottom--sm border--bottom">
                        <Row>
                            <Col xs={ 12 }>
                                <h3 className="text-weight--bold">{ t('account.orders.paymentDetails') }</h3>
                            </Col>
                        </Row>
                        <div className="order-summary__payments-wrapper">
                            { this.renderPaymentDetails('payments') }
                            { order.hasChangeoverTickets() && this.renderPaymentDetails('changeoverPayments') }
                        </div>
                    </div>
                </Col>
            </Row>
        );
    }
}

export default PaymentInformation;



// WEBPACK FOOTER //
// ./src/components/checkout/orderSummary/PaymentInformation.js